module.exports = __webpack_public_path__ + "img/arina.ea5cf319.jpg";